var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGearSix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5408 15.75C14.6118 15.75 16.2908 14.0711 16.2908 12C16.2908 9.92893 14.6118 8.25 12.5408 8.25C10.4697 8.25 8.79077 9.92893 8.79077 12C8.79077 14.0711 10.4697 15.75 12.5408 15.75Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.733 19.3228C12.6074 19.3228 12.4808 19.3228 12.358 19.3228L9.3533 21C8.1836 20.6065 7.09867 19.9959 6.15548 19.2L6.14423 15.825C6.07767 15.72 6.01486 15.6141 5.95673 15.5053L2.96892 13.8038C2.73359 12.6134 2.73359 11.3885 2.96892 10.1981L5.95392 8.50125C6.01486 8.39344 6.07767 8.28656 6.14142 8.18156L6.15642 4.80656C7.09876 4.00842 8.18341 3.39548 9.3533 3L12.3533 4.67719C12.4789 4.67719 12.6055 4.67719 12.7283 4.67719L15.7283 3C16.898 3.39346 17.9829 4.00414 18.9261 4.8L18.9374 8.175C19.0039 8.28 19.0667 8.38594 19.1249 8.49469L22.1108 10.1953C22.3461 11.3857 22.3461 12.6106 22.1108 13.8009L19.1258 15.4978C19.0649 15.6056 19.002 15.7125 18.9383 15.8175L18.9233 19.1925C17.9816 19.9908 16.8976 20.604 15.7283 21L12.733 19.3228Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.540771)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearSix);
export default __webpack_public_path__ + "static/media/gear-six.29da8806884b44bfa83fa6b2cf192b33.svg";
export { ForwardRef as ReactComponent };